import * as React from 'react';

export interface WixStyleReactEnvironmentProviderProps {
  children?: React.ReactNode;
  dataHook?: string;
  locale?: string;
  pageHeaderId?: string;
}

declare const WixStyleReactEnvironmentProvider: React.FC<WixStyleReactEnvironmentProviderProps>;
export default WixStyleReactEnvironmentProvider;
